import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GamutPaletteComponent } from './components/gamut-palette/gamut-palette.component';
import { GamutBrandingComponent } from './components/gamut-branding/gamut-branding.component';
import { GamutBrandingService } from './services/gamut-branding.service';
import { GamutPaletteService } from './services/gamut-palette.service';
import { GamutPaletteDirective } from './directives/gamut-palette.directive';
import { GamutStyleDirective } from './directives/gamut-style.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    GamutPaletteComponent,
    GamutBrandingComponent,
    GamutPaletteDirective,
    GamutStyleDirective
  ],
  exports: [
    GamutPaletteComponent,
    GamutBrandingComponent,
    GamutPaletteDirective,
    GamutStyleDirective
  ],
  providers: [
    GamutBrandingService,
    GamutPaletteService
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class GamutModule {}
